import { useLocation } from "react-router"

const useArchiveContext = () => {
    const location = useLocation();
    return /^\/archive/.test(location.pathname);
}
export default useArchiveContext;